import { SET_STRIPE_SECRET_TOKEN, SET_STRIPE_PAYABLE_AMOUNT, SET_STRIPE_MODAL, SET_STRIPE_SUBSCRIPTION, SET_STRIPE_PAYMENT, SET_STRIPE_PLANS, LOAD_STRIPE_PAYMENT, SET_PAYMENT_METHOD_SELECTION, SET_BANK_CRYPTO_DETAILS, SET_OVERRIDE_PLAN_PRODUCT_PRICE, SET_BANK_TRANSFER_BACK_TRIGGER, MANUAL_PAYMENT_PROCEEDING, SET_FORCE_CART_PAYABLE_AMOUNT, SET_HOLD_CURRENCY_AMOUNT_PAID_UP, SET_CURRENCY_WATCH, SET_TRANSACTION_STATUS, SET_TRANSACTION_STATUS_LOADER, SET_TRIPLEA_URL, SET_TRIPLEA_STATE, SET_PAYMENT_STEPS, SET_PAYMENT_RESPONSE, SET_STRIPE_PAGE_TYPE, GET_STRIPE_CARDS, SET_SELECTED_CARD, SET_OPEN_ADD_CARD_MODAL, SET_QUANTITY, SET_IS_MANUAL_PAYMENT, SET_OPEN_CART_PAGE, PAYMENT_TYPE, SET_PAYMENT_BANK_MODAL, SET_PAYMENT_BANK_MODAL_MESSAGE, SET_QUANTITY_MANUAL } from "../actions/types";
import { GOLD_QUANTITY_LIST, SUBSCRIPTION_MODULE_TYPE, SUPPORTED_PAYMENT_METHOD } from "../constants";

const initialState = {
  showStripePlanByModule: {},
  stripeToken: null,
  stripeModal: false,
  stripeType: null,
  stripeSubscription: null,
  isSubscribed: null,
  isBobSubscribed: null,
  loadSubscription: false,
  subscriptions: [],
  subscriptionsCount: 0,
  stripePlans: {},
  paymentMethodSelection: null,
  savedbankInfoDetails: null,
  isPriceDisable: false,
  isOverrideProduct: false,
  cartAmount: null,
  forceCartAmount: null,
  triggerBankTransferBack: false,
  manualPaymentProceeding: false,
  holdFromCurrencyPaidUpCapital: null,
  currencyWatchCrumbs: "",
  transactionStatus: [],
  isTransactionStatusLoading: false,
  isTripleaUrl: null,
  isTripleaState: false,
  selectedStep: 1,
  stripePageType: false,
  stripeCards: [],
  selectedCard: {},
  openAddCard: false,
  paymentResponse: null,
  selectedQuantity: GOLD_QUANTITY_LIST[0],
  isManualPayment: 0,
  openCartPage: false,
  paymentBankModal: false,
  paymentBankModalMessage: null,
  paymentType: false,
  isManualPaymentType: false,
  isManualQuantity: false,
  manualQuantity: 1,
};
export default function (state = initialState, action) {
  const { type, payload, subscriptionCount, moduleType } = action;
  switch (type) {
    case SET_STRIPE_SECRET_TOKEN:
      return {
        ...state,
        stripeToken: payload,
      };
    case SET_STRIPE_MODAL:
      return {
        ...state,
        stripeModal: payload.stripeModal,
        stripeType: payload.stripeType,
        showStripePlanByModule: payload.showStripePlanByModule,
        isManualPaymentType: false
      };

    case SET_STRIPE_SUBSCRIPTION:
      return {
        ...state,
        stripeSubscription: payload,
      };

    case SET_STRIPE_PAYMENT:
      var subscribed = false;
      var bobSubscribed = false;

      // if (payload.length > 0) {
      //   for (const [key, value] of Object.entries(SUBSCRIPTION_MODULE_TYPE)) {
      //     const payloadFilter = payload.filter(x=>x.subscriptionModuleType === value)
      //     if (payloadFilter && payloadFilter.length > 0 && payloadFilter[0].status === 'active') {
      //       if (payloadFilter[0].cancel_at_period_end && (moment().unix() > parseInt(payloadFilter[0].current_period_end))) {
      //         if(value===SUBSCRIPTION_MODULE_TYPE.SUBSCRIPTION){
      //           subscribed = false;
      //         }else if(value===SUBSCRIPTION_MODULE_TYPE.BOB) {
      //           bobSubscribed = false
      //         }
      //         break;
      //       }
      //       if(value===SUBSCRIPTION_MODULE_TYPE.SUBSCRIPTION){
      //         subscribed = true;
      //       }else if(value===SUBSCRIPTION_MODULE_TYPE.BOB) {
      //         bobSubscribed = true
      //       }
      //     }
      //   }
      // }

      return {
        ...state,
        subscriptions: payload,
        subscriptionsCount: subscriptionCount,
        isSubscribed: subscribed,
        isBobSubscribed: bobSubscribed,
        loadSubscription: false,
      };

    case LOAD_STRIPE_PAYMENT:
      return {
        ...state,
        loadSubscription: payload
      };

    case SET_STRIPE_PLANS:
      return {
        ...state,
        stripePlans: payload,
      };

    case SET_PAYMENT_METHOD_SELECTION:
      return {
        ...state,
        paymentMethodSelection: payload,
        isOverrideProduct: false,
        cartAmount: null,
        forceCartAmount: null,
        isPriceDisable: false,
        triggerBankTransferBack: false,
        manualPaymentProceeding: false
      };

    case SET_BANK_CRYPTO_DETAILS:
      return {
        ...state,
        savedbankInfoDetails: payload,
      };


    case SET_STRIPE_PAYABLE_AMOUNT:
      let isPriceDisable = (moduleType === SUBSCRIPTION_MODULE_TYPE.PAIDUPCAPITAL || (moduleType === SUBSCRIPTION_MODULE_TYPE.FUNDS || moduleType === SUBSCRIPTION_MODULE_TYPE.COMPANYFUNDS)) ? false : true;
      return {
        ...state,
        cartAmount: payload,
        isPriceDisable: isPriceDisable,
      };

    case SET_FORCE_CART_PAYABLE_AMOUNT:
      return {
        ...state,
        forceCartAmount: payload,
      };

    case SET_OVERRIDE_PLAN_PRODUCT_PRICE:
      let currentGoldPlan = state.stripePlans;
      if (currentGoldPlan && 'price' in currentGoldPlan) {
        currentGoldPlan.price = payload;
      }
      return {
        ...state,
        stripePlans: currentGoldPlan,
        isOverrideProduct: true,
      };

    case SET_BANK_TRANSFER_BACK_TRIGGER:
      return {
        ...state,
        triggerBankTransferBack: payload,
      }

    case MANUAL_PAYMENT_PROCEEDING:
      return {
        ...state,
        manualPaymentProceeding: payload,
      }

    case SET_HOLD_CURRENCY_AMOUNT_PAID_UP:
      return {
        ...state,
        holdFromCurrencyPaidUpCapital: payload
      }

    case SET_CURRENCY_WATCH:
      return {
        ...state,
        currencyWatchCrumbs: payload
      }

    case SET_TRANSACTION_STATUS:
      return {
        ...state,
        transactionStatus: payload,
        isTransactionStatusLoading: false,
      }

    case SET_TRANSACTION_STATUS_LOADER:
      return {
        ...state,
        isTransactionStatusLoading: payload
      }
    case SET_TRIPLEA_URL:
      return {
        ...state,
        isTripleaUrl: payload
      }
    case SET_TRIPLEA_STATE:
      return {
        ...state,
        isTripleaState: payload
      }
    case SET_PAYMENT_STEPS:
      return {
        ...state,
        selectedStep: payload,
      };

    case SET_STRIPE_PAGE_TYPE:
      return {
        ...state,
        stripePageType: payload
      }
    case GET_STRIPE_CARDS:
      return {
        ...state,
        stripeCards: payload
      }
    case SET_SELECTED_CARD:
      return {
        ...state,
        selectedCard: payload
      }
    case SET_OPEN_ADD_CARD_MODAL:
      return {
        ...state,
        openAddCard: payload
      }
    case SET_PAYMENT_RESPONSE:
      return {
        ...state,
        paymentResponse: payload
      }
    case SET_QUANTITY:
      return {
        ...state,
        selectedQuantity: payload
      }
    case SET_IS_MANUAL_PAYMENT:
      return {
        ...state,
        isManualPayment: payload,
        isManualPaymentType: true
      }
    case SET_OPEN_CART_PAGE:
      return {
        ...state,
        openCartPage: payload
      }

    case PAYMENT_TYPE:
      return {
        ...state,
        paymentType: payload,
      };
    case SET_PAYMENT_BANK_MODAL:
      return {
        ...state,
        paymentBankModal: payload,
      };

    case SET_PAYMENT_BANK_MODAL_MESSAGE:
      return {
        ...state,
        paymentBankModalMessage: payload,
      };

    case SET_QUANTITY_MANUAL:
      return {
        ...state,
        manualQuantity: payload?.data,
        isManualQuantity: payload?.type
      };
    default:
      return state;
  }
}
